import useMarketoFormData from 'hooks/useMarketoFormData';
import { getMarketoFormId } from 'utils/marketo';

const useCheckIsSingleEmailForm = (form) => {
  const marketoFormId = parseInt(getMarketoFormId(form));
  const marketoForm = useMarketoFormData(marketoFormId);
  const isSingleFieldForm =
    marketoForm?.fields?.filter((field) => field.dataType !== 'hidden').length === 1;
  const includesEmailField = marketoForm?.fields?.some((field) => field.id === 'Email');
  const isSingleEmailForm = isSingleFieldForm && includesEmailField;

  return isSingleEmailForm;
};

export default useCheckIsSingleEmailForm;
